import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutFunc } from "../store/Slice/AdvisorAuthSlice";
import profileImage from "../assets/images/AdvisorProfileImage.png";
import AdvisorMainContent from "../layout/AdvisorMain";

const AdvisorAccount = () => {
  const dispatch = useDispatch();
  const { user, userId, phoneNumber } = useSelector(
    (state) => state.advisorauth
  );

  const name = Array.isArray(user) ? user[0] : "";

  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(LogoutFunc());
    navigate("/");
  };

  return (
    <AdvisorMainContent>
      <div className="w-full mx-auto p-4 sm:p-6">
        <div className="bg-white border border-gray-200 rounded-lg flex items-center gap-4 p-4">
          <img
            src={profileImage}
            alt="profile"
            className="w-12 h-12 rounded-full object-cover flex-shrink-0"
          />
          <div className="flex flex-col">
            <p className="text-lg font-semibold text-gray-800 capitalize">
              {name || "Advisor"}
            </p>
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="mt-6 w-full py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors"
        >
          Logout
        </button>
      </div>
    </AdvisorMainContent>
  );
};

export default AdvisorAccount;
